/* © 2023 Promethean. All Rights Reserved.
 *
 * Unauthorized copying of this file or any part of this file
 * via any medium is strictly prohibited.
 */
import { useEffect } from 'react';
import { SKIP_COMMAND_RESET_ID } from '../header';
export var useResetSkipToMain = function useResetSkipToMain() {
  var resetCondition = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  useEffect(function () {
    var _document;
    var skipResetELement = document.querySelector("#".concat(SKIP_COMMAND_RESET_ID));
    // Do do not want to force focus to skip to main if cookiebot modal appears
    if ((_document = document) !== null && _document !== void 0 && (_document = _document.cookie) !== null && _document !== void 0 && _document.split(';').map(function (c) {
      return c.trim();
    }).filter(function (c) {
      return c.startsWith('CookieConsent=');
    }).length) {
      var _skipResetELement$foc;
      skipResetELement === null || skipResetELement === void 0 || (_skipResetELement$foc = skipResetELement.focus) === null || _skipResetELement$foc === void 0 || _skipResetELement$foc.call(skipResetELement);
    }
  }, [window.location.pathname, window.location.search].concat(resetCondition));
};